import S from './styles';

const ContentPlaceholder = ({ children }) => (
  <S.Container>
    <S.Label>{children}</S.Label>
  </S.Container>
);

export default ContentPlaceholder;
